module.exports = __webpack_public_path__ + "img/client5.6cc734cc.png";